import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-form-complete',
    templateUrl: './form-complete.component.html',
    styleUrls: ['./form-complete.component.scss'],
    standalone: false
})
export class FormCompleteComponent {

  title: string;
  description: string;

  constructor(
    private dialogRef: MatDialogRef<FormCompleteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; description?: string }
  ) {
    this.title = data?.title || 'Formulario completado';
    this.description = data?.description || '';
  }

  confirm(): void {
    this.dialogRef.close();
  }
}
